<template>
	<a class="seo-update-bar" :href="content.link||'#'" target="_blank" rel="noopener" v-if="content">
		<span class="seo-update-icon">
			<font-awesome-icon icon="bolt" />
		</span>
		<span class="seo-update-title">{{content.title}}</span>
		<span class="seo-update-text">
			{{ content.text }}
		</span>
		<span class="seo-update-link" target="_blank" rel="noopener" v-if="content.link">Learn more</span>
	</a>
</template>

<script>
	import { mapState,  mapActions } from 'vuex';

	export default {
		name: "SeoUpdateBar",
		data() {

			return {
				
			}

		},
		computed: {

			...mapState('general',['dashboardUpdates','dashboardUpdatesLoaded']),

			content () {
				if ( !this.dashboardUpdatesLoaded || !this.dashboardUpdates.length ) return null;
				return {
					title: this.dashboardUpdates[0].title,
					text: this.dashboardUpdates[0].text,
					link: this.dashboardUpdates[0].link,
				}

			}

		},
		methods: {

			...mapActions('general',['loadDashboardUpdates']),

		},
		created() {
			this.loadDashboardUpdates();
		}
	};
</script>

<style lang="less" scoped>
	@import "./../../assets/css/less/_settings.less";
	.seo-update-bar {
		display: flex;
		align-items: center;
		background: #f5f7fa;
		border-radius: 6px;
		padding: 12px 18px;
		margin-bottom: 18px;
		font-size: 1.05rem;
		text-decoration: none;
		.seo-update-icon {
			color: @formDefaultColour;
			font-size: 1.3em;
			margin-right: 10px;
			display: flex;
			align-items: center;
		}
		.seo-update-title {
			font-weight: bold;
			margin-right: 6px;
		}
		.seo-update-text {
			color: #222;
			margin-right: 10px;
			flex: 1 1 auto;
		}
		.seo-update-link {
			color: @formDefaultColour;
			font-weight: 600;
			margin-left: 8px;
		}
		&:hover {
			.seo-update-link {
				text-decoration: underline;
			}
		}
	}
</style>
